import React,{useState} from 'react'
import ReturnInvoiceForm from './ReturnInvoiceForm';

import ReturnInvoiceList from './ReturnInvoiceList';

const SalesReturnInvoice = () => {
 
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
  
  return (
    <>
      {fromIsShown ? (
          <ReturnInvoiceForm addForm={setFromIsShown} update={upData} />
        ) : (
          <ReturnInvoiceList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default SalesReturnInvoice